import { apiEndpoints } from './common'

import { makeRequestUrl } from '../app/helpers'
import { get } from '../request'

// Centre Audit > Scorecard. Facts only — Keka days, moments per day and the
// Classroom Observations per teacher; the page turns them into /5 scores.
// Returns { weeks: [Monday ISO...], start, end, keka_latest, total,
// teachers: [{ no, name, job, dept, cc, linked, days: { iso: { s, st, in,
// late } }, moments: { iso: n }, observations: [{ d, kind, title, by,
// env: [{ label, a }], fac }] }] }. offset/limit page the teachers (same order
// every call); total is how many there are in all.
// No limit = every teacher. The limit always goes in the URL: request.js adds
// limit=25 to any GET whose URL has none, which cut the page to the first 25
// teachers (23 Oct).
const EVERY_TEACHER = 1000

export const getTeacherScorecard = async ({
  end,
  weeks,
  offset,
  limit
} = {}) => {
  const params = { limit: limit || EVERY_TEACHER }
  if (end) params.end = end
  if (weeks) params.weeks = weeks
  if (offset) params.offset = offset
  const response = await get(
    makeRequestUrl(apiEndpoints.teacherScorecard, params)
  )
  return response.data
}
